import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, Chip, LinearProgress } from '@mui/material';

// 🧳 Резервна копія v2: створення/видалення/♻️відновлення БД + хід подій.
// Дії виконує агент на n8n (до 2 хв на підхоплення заявки).
export default function BackupPage() {
  const [kits, setKits] = useState([]);
  const [active, setActive] = useState([]);
  const [events, setEvents] = useState([]);
  const [msg, setMsg] = useState('');
  const [dl, setDl] = useState(null); // {name, pct}
  const tok = localStorage.getItem('dashboard_token');
  const H = { Authorization: 'Bearer ' + tok };

  const load = () => {
    fetch('/api/full-backup/status', { headers: H }).then(r => r.json())
      .then(d => { setKits((d && d.kits) || []); setActive((d && d.active) || []); }).catch(() => {});
    fetch('/api/full-backup/events?limit=40', { headers: H }).then(r => r.json())
      .then(d => setEvents((d && d.events) || [])).catch(() => {});
  };
  useEffect(() => { load(); const i = setInterval(load, 5000); return () => clearInterval(i); }, []);

  const flash = (t) => { setMsg(t); setTimeout(() => setMsg(''), 5000); };
  const post = async (url, okMsg) => {
    try {
      const r = await fetch(url, { method: 'POST', headers: H });
      const d = await r.json().catch(() => ({}));
      flash(r.ok ? okMsg : '⚠️ ' + (d.detail || ('помилка ' + r.status)));
    } catch (e) { flash('⚠️ помилка мережі'); }
    load();
  };

  const createNow = () => post('/api/full-backup/create',
    '🧳 Заявку прийнято! Агент підхопить до 2 хв, збірка 2-5 хв — стежте у «Хід подій».');

  const del = (name) => {
    if (!window.confirm('Видалити копію ' + name + '?')) return;
    post('/api/full-backup/delete?name=' + encodeURIComponent(name), '🗑 Заявку на видалення прийнято.');
  };

  const restore = (name) => {
    const word = window.prompt(
      '♻️ УВАГА: база даних (юзери, платежі, реферали) буде ЗАМІНЕНА даними з копії:\n' + name +
      '\n\nПоточна база спершу автоматично збережеться у страховку.' +
      '\n\nЩоб підтвердити — введіть слово: ВІДНОВИТИ');
    if (word !== 'ВІДНОВИТИ') { flash('Скасовано.'); return; }
    post('/api/full-backup/restore?name=' + encodeURIComponent(name),
      '♻️ Заявку на відновлення прийнято! Хід — у журналі нижче (4 кроки, ~3-5 хв).');
  };

  const download = async (name) => {
    setDl({ name, pct: 0 });
    try {
      const r = await fetch('/api/full-backup/download?name=' + encodeURIComponent(name), { headers: H });
      if (!r.ok) { flash('⚠️ помилка ' + r.status); setDl(null); return; }
      const total = +r.headers.get('Content-Length') || 0;
      const reader = r.body.getReader();
      const chunks = []; let got = 0;
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value); got += value.length;
        if (total) setDl({ name, pct: Math.round(got / total * 100) });
      }
      setDl({ name, pct: 100 });
      const blob = new Blob(chunks);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = name; a.click();
      URL.revokeObjectURL(url);
      flash('✅ Завантажено — збережіть на флешку!');
    } catch (e) { flash('⚠️ обрив завантаження — спробуйте ще раз'); }
    setTimeout(() => setDl(null), 2500);
  };

  const evIcon = { request: '📨', start: '▶️', info: '🔹', done: '✅', error: '❌' };
  const evColor = { done: '#4caf50', error: '#f44336', start: '#ff9800', info: '#90caf9', request: '#aaa' };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ color: '#FFD700', mb: 2 }}>🧳 Резервна копія (валіза виживання)</Typography>

      <Paper sx={{ p: 2, mb: 2, bgcolor: '#1a1a2e' }}>
        <Typography variant="body2" sx={{ color: '#ccc' }}>
          Повна портативна копія: <b>вся БД</b> + <b>код</b> + <b>конфіги</b> + інструкція відбудови.
          Автокопія щонеділі 04:30, зберігаються останні 4. 🔐 AES-256 (потрібен майстер-пароль з паперу).
        </Typography>
        <Box sx={{ mt: 1.5, display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
          <Button variant="contained" onClick={createNow}
            sx={{ bgcolor: 'var(--ac1, #7c4dff)', '&:hover': { bgcolor: 'var(--ac1d, #5e35d6)' } }}>
            🧳 Створити копію зараз
          </Button>
        </Box>
        {active.map(a => {
          const label = { create: '🧳 Створення копії', delete: '🗑 Видалення', restore: '♻️ Відновлення БД' }[a.action] || a.action;
          // для restore тягнемо крок N/4 з останніх подій
          let pct = null, step = '';
          if (a.action === 'restore') {
            const ev = events.find(e => (e.message || '').includes('крок'));
            const m = ev && ev.message.match(/крок (\d)\/4/);
            if (m) { pct = (+m[1]) * 25; step = ' — крок ' + m[1] + '/4'; }
          }
          return (
            <Box key={a.id} sx={{ mt: 1.5 }}>
              <Typography variant="caption" sx={{ color: '#ff9800' }}>
                {label}{step} — {a.status === 'processing' ? 'виконується…' : 'у черзі (агент підхопить до 2 хв)'}
              </Typography>
              <LinearProgress variant={pct != null ? 'determinate' : 'indeterminate'} value={pct || 0}
                sx={{ height: 8, borderRadius: 4, mt: 0.5, bgcolor: '#333',
                  '& .MuiLinearProgress-bar': { bgcolor: '#ff9800', borderRadius: 4 } }}/>
            </Box>
          );
        })}
        {dl && (
          <Box sx={{ mt: 1.5 }}>
            <Typography variant="caption" sx={{ color: 'var(--ac1, #7c4dff)' }}>⬇️ Завантаження {dl.name.slice(13, 26)}… {dl.pct}%</Typography>
            <LinearProgress variant="determinate" value={dl.pct}
              sx={{ height: 8, borderRadius: 4, mt: 0.5, bgcolor: '#333',
                '& .MuiLinearProgress-bar': { bgcolor: 'var(--ac1, #7c4dff)', borderRadius: 4 } }}/>
          </Box>
        )}
        {msg && <Typography variant="caption" sx={{ color: '#4caf50', display: 'block', mt: 1 }}>{msg}</Typography>}
      </Paper>

      <Typography variant="subtitle1" sx={{ color: '#fff', mb: 1 }}>📦 Доступні копії</Typography>
      {kits.length === 0 && <Typography variant="body2" sx={{ color: '#888' }}>Копій поки немає.</Typography>}
      {kits.map((k, i) => (
        <Paper key={k.name} sx={{ p: 2, mb: 1, bgcolor: '#16213e', display: 'flex',
          justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Box>
            <Typography sx={{ color: '#fff' }}>
              {k.name} {i === 0 && <Chip size="small" label="найновіша"
                sx={{ ml: 1, bgcolor: 'rgba(76,175,80,0.2)', color: '#4caf50' }}/>}
            </Typography>
            <Typography variant="caption" sx={{ color: '#888' }}>{k.created} · {k.size_mb} MB</Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button size="small" variant="contained" onClick={() => download(k.name)}
              sx={{ bgcolor: 'var(--ac1, #7c4dff)', '&:hover': { bgcolor: 'var(--ac1d, #5e35d6)' } }}>⬇️ Завантажити</Button>
            <Button size="small" variant="outlined" color="warning" onClick={() => restore(k.name)}>♻️ Відновити БД</Button>
            <Button size="small" variant="outlined" color="error" onClick={() => del(k.name)}>🗑</Button>
          </Box>
        </Paper>
      ))}

      <Typography variant="subtitle1" sx={{ color: '#fff', mt: 2, mb: 1 }}>📜 Хід подій</Typography>
      <Paper sx={{ p: 1.5, bgcolor: '#0f1420', maxHeight: 280, overflowY: 'auto' }}>
        {events.length === 0 && <Typography variant="caption" sx={{ color: '#888' }}>Подій ще не було.</Typography>}
        {events.map(ev => (
          <Box key={ev.id} sx={{ display: 'flex', gap: 1, py: 0.3, borderBottom: '1px solid #1c2333' }}>
            <Typography variant="caption" sx={{ color: '#666', minWidth: 130 }}>
              {ev.created_at ? new Date(ev.created_at).toLocaleString('uk-UA', { hour12: false }) : ''}
            </Typography>
            <Typography variant="caption" sx={{ color: evColor[ev.kind] || '#aaa' }}>
              {(evIcon[ev.kind] || '•') + ' ' + ev.message}
            </Typography>
          </Box>
        ))}
      </Paper>
    </Box>
  );
}
